/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import axios from 'axios'
import moment from 'moment'
import React, { useContext, useLayoutEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Link } from 'react-router-dom'

import clsx from 'clsx'

import {
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  Tooltip
} from '@material-ui/core'
import { Edit, EventAvailable } from '@material-ui/icons'

import deburr from 'lodash.deburr'
import ButtonGZ from '../../components/Button'
import useStyles from './styles'

import Context from '../../context'
import { getHighlightList, removeHighlight } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function HighLightsList() {
  const classes = useStyles()
  const { user, setUser, setAboutCurrentPage } = useContext(Context)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState('0')
  const [query, setQuery] = useState('')
  const [checked, setChecked] = useState([])
  const [deleteModalData, setDeleteModalData] = useState(null)
  const [showPostModal, setShowPostModal] = useState(null)
  const [buttonState, setButtonState] = useState(false)

  const listUpdate = async () => {
    setLoading(true)

    return getHighlightList(null,null,user.whiteLabelId);
  }

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }
    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: 'Destaques',
      buttons: [
        {
          title: 'Novo Post',
          // pathname: '/muralform',
          pathname: '/highlighttype'
        }
      ]
    })

    listUpdate().then(res => {
      setData(res)
      setLoading(false)
    })
  }, [])

  async function getData() {
    try {
      setLoading(true)
      listUpdate().then(res => setData(res))
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  let errorMessage = ''
  let finalData = []

  finalData = (() => {
    try {
      let newData = data

      if (sortBy === '1')
        newData = newData.sort((one, another) => one.title.localeCompare(another.title))
      if (sortBy === '2')
        newData = newData.sort(
          (one, another) => new Date(one.createdAt) - new Date(another.createdAt)
        )
      return newData.filter(item => new RegExp(deburr(query), 'i').test(deburr(item.title)))
    } catch (err) {
      errorMessage = React.createElement(
        'div',
        { className: 'container' },
        <ButtonGZ color="primary" onClick={() => history.go(0)}>
          Atualize a página!
        </ButtonGZ>
      )
      console.error(err)
    }
  })()

  function handleSortByChange(e) {
    setSortBy(e.target.value)
  }

  function handleQueryChange(e) {
    setQuery(e.target.value)
  }

  function hidePostModal() {
    setShowPostModal(null)
  }

  function setToBeDeleted(item) {
    return () => {
      const whiteLabelList = item?.WhiteLabelMuralWhiteLabelLists || []
      const whiteLabelListAssociated = whiteLabelList.map(list => {
        return {
          whiteLabelId: list.whiteLabelId,
          whiteLabelMuralId: list.whiteLabelMuralId,
          title: list.WhiteLabel?.title || 'Clube Gazeta'
        }
      })
      setDeleteModalData({
        ...item,
        partnerList: item.Partners ? item.Partners : null
      })
    }
  }

  function setAllToBeDeleted() {
    // console.log('All checked: ', checked);
    const settedToBeDeleted = finalData
      .map(item => {
        return checked.includes(item.id) ? item : null
      })
      .filter(Boolean)

    const updatedToBeDeleted = settedToBeDeleted.map(selected => {
      const whiteLabelList = selected?.WhiteLabelMuralWhiteLabelLists || []
      const whiteLabelListAssociated = whiteLabelList.map(item => {
        return {
          whiteLabelId: item.whiteLabelId,
          whiteLabelMuralId: item.whiteLabelMuralId,
          title: item.WhiteLabel?.title || 'Clube Gazeta'
        }
      })
      return {
        ...selected,
        partnerList: selected.Partners ? selected.Partners : null
        // whiteLabelMuralWhiteLabelList: whiteLabelListAssociated,
      }
    })
    setDeleteModalData(updatedToBeDeleted)
  }

  function hideDeleteModal() {
    setDeleteModalData(null)
  }

  function handleCheckUnit(name) {
    if (checked.includes(name)) {
      setChecked(checked => checked.filter(item => item !== name))
    } else {
      setChecked([...checked, name])
    }
  }

  function checkAll() {
    setChecked(finalData?.length !== checked?.length ? finalData?.map(({ id }) => id) : [])
  }

  async function deleteItem(item) {
    try {
      setDeleteModalData(null)
      setLoading(true)
      await removeHighlight(item.id)
      await listUpdate().then(data => setData(data))
      await getData()
    } catch (err) {
      console.log(err)
    }
  }

  async function deleteAllItems(items) {
    try {
      setDeleteModalData(null)
      setLoading(true)
      items.forEach(async element => {
        await removeHighlight(element.id)
      })

      await listUpdate().then(data => setData(data))
      await getData()
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
      setChecked([])
    }
  }

  const handleDragEnd = e => {
    if (!e.destination) return
    const tempData = Array.from(finalData)
    const [sourceData] = tempData.splice(e.source.index, 1)
    tempData.splice(e.destination.index, 0, sourceData)
    setData(tempData)
    setButtonState(true)
  }

  async function updateOrderHighlights() {
    setLoading(true)
    for (const [index, list] of data.entries()) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await axios.post(
          `${process.env.REACT_APP_API_CORE}highlights/updateOrder/${list.id}/${index}`
        )
      } catch (e) {
        console.log(e)
      }
    }
    listUpdate().then(res => setData(res))
    setButtonState(false)
    setLoading(false)
    history.go(0)
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div className={classes.actions}>
                {checked.length > 0 ? (
                  <button
                    type="button"
                    className={classes.actionsBtn}
                    onClick={() => setAllToBeDeleted()}
                  >
                    Excluir
                  </button>
                ) : (
                  ''
                )}
              </div>
              <select className={classes.sorting} value={sortBy} onChange={handleSortByChange}>
                <option disabled value="0">
                  Ordenar por:
                </option>
                <option value="1">Título do Post</option>
                <option value="2">Data de publicação</option>
              </select>
            </div>
            <input
              className={classes.search}
              value={query}
              onChange={handleQueryChange}
              placeholder="Buscar..."
            />
          </div>

          <DragDropContext onDragEnd={handleDragEnd}>
            <table className={classes.table}>
              <thead>
                <colgroup className={classes.hide}>
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                </colgroup>
                <tr>
                  {
                    user.whiteLabelId === null && (
                      <th>
                      {buttonState ? (
                        <ButtonGZ
                          className={classes.updateButton}
                          onClick={() => updateOrderHighlights()}
                        >
                          Atualizar
                        </ButtonGZ>
                      ) : null}
                    </th>
                    )
                  }
                  <th scope="col" className={classes.checkboxHighlight}>
                    <Checkbox
                      className="checkbox-lines"
                      value="All"
                      onChange={checkAll}
                      className={classes.headerCheckbox}
                      checked={checked?.length === finalData?.length && finalData?.length > 0}
                    />
                  </th>
                  <th scope="col">Título</th>
                  <th scope="col">Empresa</th>
                  <th scope="col">Data de Publicação</th>
                  <th scope="col">Tipo</th>
                </tr>
              </thead>
              <Droppable droppableId="droppable-1">
                {provider => (
                  <tbody
                    className="text-capitalize"
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {finalData?.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.orderList} index={index}>
                        {provider => (
                          <tr {...provider.draggableProps} ref={provider.innerRef}>
                            {
                              user.whiteLabelId === null && (
                                <td {...provider.dragHandleProps}> = </td>
                              )
                            }
                            <td>
                              <Checkbox
                                value={item.id}
                                checked={checked.includes(item.id)}
                                onChange={() => handleCheckUnit(item.id)}
                                color="primary"
                              />
                            </td>
                            <td>
                              <div className="wrapper-post-title">
                                <div className="post-title">
                                  {item.title}{' '}
                                  {item.situation === 3 && (
                                    <Tooltip title="Rascunho">
                                      <Edit fontSize="small" />
                                    </Tooltip>
                                  )}
                                  {!!item.publishedDate && moment(item?.publishedDate) ? (
                                    <Tooltip title="Agendado">
                                      <EventAvailable fontSize="small" />
                                    </Tooltip>
                                  ) : (
                                    ''
                                  )}
                                </div>
                                <div>
                                  <Link
                                    to={{ pathname: '/muralform', state: item }}
                                    className="link-edit"
                                  >
                                    Editar
                                  </Link>
                                  | <a onClick={() => setShowPostModal(item)}>Visualizar</a>|
                                  <a className="link-delete" onClick={setToBeDeleted(item)}>
                                    Excluir
                                  </a>
                                </div>
                              </div>
                            </td>
                            <td>
                              {' '}
                              {item.WhiteLabel ? (
                                <span>{item.WhiteLabel.title}</span>
                              ) : (
                                <span>Todas as Empresas</span>
                              )}
                            </td>
                            <td>
                              {' '}
                              {item.publishedDate
                                ? moment(item.publishedDate).format('L [às] LT')
                                : moment(item.createdAt).format('L [às] LT')}
                            </td>
                            <td>
                              {(() => {
                                if (item.typeHighlight === 'mural') {
                                  return <Chip className={classes.chip} label="Mural" />
                                }
                                if (item.typeHighlight === 'partnerList') {
                                  return (
                                    <Chip className={classes.chip} label="Lista de Parceiros" />
                                  )
                                }
                                if (item.typeHighlight === 'directLink') {
                                  return <Chip className={classes.chip} label="Link Direto" />
                                }
                              })()}
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provider.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>

          {finalData?.length === 0 && errorMessage === '' && !loading ? (
            <div className="alert alert-info text-center m-4">
              Nenhum post encontrado. <Link to="/highlighttype">Crie o primeiro aqui.</Link>
            </div>
          ) : (
            ''
          )}
          {errorMessage}
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>
      <Dialog
        open={!!deleteModalData}
        onClose={hideDeleteModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir o Post</DialogTitle>
        {/* {console.log('Excluir', deleteModalData)} */}
        <DialogContent>
          <DialogContentText>
            {Array.isArray(deleteModalData)
              ? `Deseja realmente excluir os posts ${deleteModalData.map(
                  item => `${item.title} `
                )}?`
              : `Deseja realmente excluir o post ${deleteModalData?.title}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideDeleteModal}>
            Não
          </ButtonGZ>
          {Array.isArray(deleteModalData) ? (
            <ButtonGZ color="primary" onClick={() => deleteAllItems(deleteModalData)}>
              Sim
            </ButtonGZ>
          ) : (
            <ButtonGZ color="primary" onClick={() => deleteItem(deleteModalData)}>
              Sim
            </ButtonGZ>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!showPostModal}
        onClose={hidePostModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="sm"
      >
        {/* {console.log('dados aqui', showPostModal)} */}
        {showPostModal?.typeHighlight === 'partnerList' ? (
          <>
            <DialogTitle>
              Post <strong> {showPostModal?.title}</strong>{' '}
              <Chip className={classes.chip} label="Lista de Parceiros" />
            </DialogTitle>

            <DialogContent dividers>
              {!!showPostModal?.createdAt && (
                <DialogContentText>
                  <EventAvailable />
                  {moment(showPostModal?.createdAt).format('L [às] LT')}
                </DialogContentText>
              )}
              <img src={process.env.REACT_APP_IMAGES_URL + showPostModal?.image} width="100%" />

              <DialogContentText>
                {showPostModal?.Partners?.map(partners => (
                  <ul key={partners.id}>
                    <li>{partners.fantasyName}</li>
                  </ul>
                  // <span key={partners.id}>{partners.fantasyName}</span>
                ))}
              </DialogContentText>
              <DialogContentText className={clsx({ [classes.hide]: user?.userGroup === 6 })}>
                Grupos:
                <strong>{showPostModal?.whiteLabelId ? ' Clube Gazeta ' : null}</strong>
              </DialogContentText>
            </DialogContent>
          </>
        ) : (
          <div>
            <DialogTitle>
              Post <strong> {showPostModal?.title}</strong>{' '}
              {!!showPostModal?.featured && <Chip className={classes.chip} label="Destaque" />}
            </DialogTitle>

            <DialogContent dividers>
              {!!showPostModal?.createdAt && (
                <DialogContentText>
                  <EventAvailable />
                  {moment(showPostModal?.createdAt).format('L [às] LT')}
                </DialogContentText>
              )}
              <img src={process.env.REACT_APP_IMAGES_URL + showPostModal?.image} width="100%" />

              <DialogContentText>
                <div
                  dangerouslySetInnerHTML={{
                    __html: showPostModal?.content
                  }}
                />
              </DialogContentText>
              <DialogContentText className={clsx({ [classes.hide]: user?.userGroup === 6 })}>
                Grupos:
                {/* <strong>
              {showPostModal?.clubeApp ? 'Clube Gazeta ' : null}
              {`${showPostModal?.WhiteLabelMuralWhiteLabelLists.map(
                group => `${group.WhiteLabel?.title} `
              )}`}
            </strong> */}
              </DialogContentText>
              <DialogContentText>{showPostModal?.calltoaction}</DialogContentText>
              <DialogContentText>
                <a href={showPostModal?.link}>{showPostModal?.link}</a>
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <ButtonGZ color="secondary" onClick={() => hidePostModal()}>
                Fechar
              </ButtonGZ>
            </DialogActions>
          </div>
        )}
      </Dialog>
    </>
  )
}

export default HighLightsList
